var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"color":"rgba(255, 0, 0, 0)","flat":"","floating":"","role":"slider","id":"time-slider"}},[_c('div',{staticClass:"time-slider-wrapper"},[_c('input',{staticClass:"slider",attrs:{"type":"text","name":"slider","value":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }